// src/stone/illustrations/StonjiCardErrorIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiCardErrorIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 54 48",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#stonji-card-error_Illustration_svg__a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E8E9EA",
            d: "m41.59 24.204-6.26 3.168-17.155 8.678-1.595.807-2.357 1.192a4.07 4.07 0 0 1-2.986.277 4.08 4.08 0 0 1-2.506-2.088L.439 19.788a4.1 4.1 0 0 1 1.808-5.502L29.614.44a4.087 4.087 0 0 1 5.492 1.811l7.712 15.303.58 1.148a4.1 4.1 0 0 1-1.808 5.502"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "m14.156 20.541 2.424 16.318-2.357 1.192a4.07 4.07 0 0 1-2.753.337z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "m11.043 37.75-.025-.003a.14.14 0 0 1-.11-.16l3.113-17.072a.137.137 0 0 1 .16-.11.14.14 0 0 1 .11.159l-3.114 17.073a.14.14 0 0 1-.134.112"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#BBBDBF",
            d: "M49.244 34.579 18.92 39.117a4.09 4.09 0 0 1-4.647-3.445l-2.718-18.229a4.095 4.095 0 0 1 3.439-4.656L45.318 8.25a4.09 4.09 0 0 1 4.647 3.445l2.718 18.228a4.096 4.096 0 0 1-3.44 4.656"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M17.401 29.275a.137.137 0 0 1-.02-.272l21.151-3.16a.135.135 0 0 1 .155.115.137.137 0 0 1-.115.156l-21.15 3.16zM26.166 30.37a.137.137 0 0 1-.02-.272l9.115-1.362c.075-.011.144.04.155.115a.137.137 0 0 1-.115.155l-9.115 1.362zM17.776 31.625a.137.137 0 0 1-.02-.272l6.792-1.015a.135.135 0 0 1 .154.114.137.137 0 0 1-.115.156l-6.791 1.015zM50.093 12.57l-38.41 5.754.75 5.024 38.41-5.755z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FCFCFC",
            stroke: "#FCFCFC",
            d: "m46.452 13.612-1.262 4.321-3.924.588 1.262-4.32zM48.965 13.235l-1.263 4.32-.328.05 1.262-4.32z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#DD4F40",
            d: "M43.818 48C49.441 48 54 43.433 54 37.799S49.44 27.598 43.818 27.598s-10.182 4.567-10.182 10.2C33.636 43.434 38.195 48 43.818 48"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FCFCFC",
            d: "M48.704 41.179a1.073 1.073 0 0 1-.756 1.828c-.274 0-.547-.105-.756-.314l-3.374-3.38-3.374 3.38a1.064 1.064 0 0 1-1.512 0 1.07 1.07 0 0 1 0-1.514l3.375-3.38-3.375-3.381a1.07 1.07 0 0 1 0-1.515 1.07 1.07 0 0 1 1.512 0l3.374 3.381 3.374-3.38a1.07 1.07 0 0 1 1.511 0 1.073 1.073 0 0 1 0 1.514l-3.373 3.38z"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "stonji-card-error_Illustration_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h54v48H0z" }) }) })
    ]
  }
);
var StonjiCardErrorIllustration_default = StonjiCardErrorIllustration;

export {
  StonjiCardErrorIllustration,
  StonjiCardErrorIllustration_default
};
